import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/master-role?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/master-role', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/master-role/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/master-role/${body.id}`, body.body);
};
export const UPDATE_ROLE_MENUS_DATA = (body) => {
    return axiosIns.post('/master-role/update-role-menu', body);
};
export const GET_LIST = () => {
    return axiosIns.get(`/master-role/list`);
};